
<!-- NO TEMPLATE AS NOTHING IS CURRENTLY RENDERED
<template>
</template>
-->


<script>
import {userStore} from "@/userStore";
import axios from "axios";
import {EventBus} from "@/eventBus";
import analytics from "@/analytics";

export default {
  name: "DebuggingComponent",

  mounted() {
    window.debugToggleFilmViewed = this.toggleFilmViewed;
    window.debugAutomatedSmoothScroll = this.automatedSmoothScroll;
    window.addEventListener('keyup', this.onKeyUp);
  },

  beforeUnmount() {
    window.debugToggleFilmViewed = undefined;
    window.debugAutomatedSmoothScroll = undefined;
    window.removeEventListener('keyup', this.onKeyUp);
  },

  methods: {

    onKeyUp(_event) {
      // ctrl+alt+1: scrolls down a little, smoothly
      if ( _event.ctrlKey && _event.altKey && (_event.key === '1') ) {
        this.automatedSmoothScroll(500, 300, true);
      }

      // ctrl+alt+2: scrolls down a little, quickly
      if ( _event.ctrlKey && _event.altKey && (_event.key === '2') ) {
        this.automatedSmoothScroll(500, 800, true);
      }

      // ctrl+alt+3: scrolls down a lot, smoothly
      if ( _event.ctrlKey && _event.altKey && (_event.key === '3') ) {
        this.automatedSmoothScroll(100000, 300);
      }
    },

    automatedSmoothScroll(pixels, pixelsPerSecond, easeInEaseOut=false) {
      const start = window.pageYOffset;
      let startTime = null;

      const durationMs = (pixels / pixelsPerSecond) * 1000;
      //console.log('speed', pixelsPerSecond);

      const easeInOutSine = t => -(Math.cos(Math.PI * t) - 1) / 2;

      const animation = currentTime => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = easeInEaseOut? easeInOutSine(Math.min(timeElapsed / durationMs, 1)) : Math.min(timeElapsed / durationMs, 1);

        const distanceCovered = pixels * progress;
        window.scrollTo({
          top: start + distanceCovered,
          left: 0,
          behavior: 'instant'
        });

        if ( (timeElapsed < durationMs) && !this.isScrollAtBottom() ) {
          requestAnimationFrame(animation);
        }
      };
      requestAnimationFrame(animation);
    },

    isScrollAtBottom() {
      // Use pageYOffset for better cross-browser support (IE9+)
      const scrollPosition = window.innerHeight + (window.pageYOffset || window.scrollY);
      const totalHeight = document.documentElement.scrollHeight;

      // Use >= and a small threshold (like 1px) to handle subpixel rounding issues
      return (scrollPosition >= totalHeight - 1);
    },

    async toggleFilmViewed(_film_id) {
      //console.log(`debugToggleFilmViewed( ${_film_id} )`);
      if ( !userStore.isLoggedIn() ) {
        return;
      }

      axios.post(`/api/user/viewed/${_film_id}/${userStore.isFilmMarkedViewed(_film_id)? 'false' : 'true'}`)
          .then(response => {
            // If, for some reason, we're trying to mark a film as viewed or unviewed,
            //  that already IS marked that way, we return a 204 (no content).
            if ( response.status === 200 ) {
              userStore.setUser(response.data);
              EventBus.emit('viewed-state-updated', _film_id);
              return axios.get(`/api/achievements/${_film_id}`);
            }
          })
          .then(response => {
            const achievements = response?.data;

            console.log('achievements', achievements);

            achievements?.forEach(achievement => {
              if ( achievement.films.every(film => userStore.isFilmMarkedViewed(film)) ) {
                EventBus.emit('achievement-notification', {
                  achievementType: 'CATEGORY_COMPLETE',
                  category: achievement.category,
                  normalized_category: achievement.normalized_category,
                  ceremony: achievement.ceremony,
                  numFilmsViewed: achievement.films.length
                });
              }
            });
          })
          .catch(err => {
            analytics.notifyBugsnagOfError(err);
          });
    },
  }
}
</script>


<style scoped>

</style>